import './index.css';
import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { App } from "./components/App";
import { initAnalytics } from "./utils/analytics";
import { setClientContext } from "./utils/sentryLogger";
import { getClientInfo } from "./hooks/useClientInfo";
import { appEnvironment } from "./utils/environment";

const sentryEnv = appEnvironment();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: sentryEnv,
  release: `oko-web@${process.env.REACT_APP_VERSION || "0.1.0"}`,
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    Sentry.browserTracingIntegration(),
  ],
  enableLogs: true,
  tunnel: `${process.env.REACT_APP_OKOLABS_API_ENDPOINT}/api/sentry-tunnel`,
  tracesSampleRate: sentryEnv === "prod" ? 0.2 : 1.0,
  tracePropagationTargets: [
    /^https:\/\/api\.(dev\.)?okolabs\.ai/,
    "localhost",
  ],
});

// Telemetry enrichment must never be able to blank the app before it renders.
try {
  setClientContext(getClientInfo());
} catch (e) {
  Sentry.captureException(e);
}
initAnalytics();

ReactDOM.render(<App />, document.getElementById("root"));
